import React from "react";
import element3 from '../../assets/images/element_white_3.webp';
import element4 from '../../assets/images/element_white_4.webp';
import customer from '../../assets/images/customer-icon.webp';
import { Link } from "react-router-dom";
const Call = () => {
    return (
        <>
            <section className="cta_section new white_text" id="support_sec">
             
                <div className="container">
                    <div className="cta_box">
                        <div className="element">
                            <span className="element1">
                              
                                <img src={element3} alt="image" />{" "}
                            </span>
                            <span className="element2">
                               
                                <img src={element4} alt="image" />{" "}
                            </span>
                        </div>
                        <div className="left">
                            <div
                                className="section_title"
                                data-aos="fade-in"
                                data-aos-duration={1500}
                                data-aos-delay={100}
                            >
                                <img
                                    src={customer}
                                    className="customer_icon"
                                    alt="image"
                                />
                                
                                <h3>Need support?</h3>
                                
                                <p>Lorem Ipsum is simply dummy text of the printing.</p>
                            </div>
                        </div>
                        <div className="right">
                            <div className="btn_block ">
                                <Link
                                    to="tel:123-456-7890"
                                    className="btn puprple_btn aos-init aos-animate call_btn"
                                >
                                    <i className="icofont-ui-call" /> Call us now
                                </Link>
                                <Link
                                    to="mailto:someone@example.com"
                                    className="btn aos-init aos-animate email_btn"
                                >
                                    <i className="icofont-envelope-open" /> Email us
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
             
            </section>

        </>
    )
}
export default Call;